// extracted by mini-css-extract-plugin
export default {"form-team__input-text":"GeneralInfoTeamFormView_form-team__input-text__AEMHx"};